import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './AppRouter';
import { errorBoundry } from './components/ErrorBoundry/ErrorBoundry';
import 'moment/locale/nl';
import { LocaleProvider } from 'antd';
import nl_NL from 'antd/lib/locale-provider/nl_NL';
import { DefaultAuthState } from './core-module/models/redux/DefaultAuthState';
import { Dispatch } from 'redux';
import { isTokenValid } from './core-module/helpers/AuthHelper';
import { connect } from 'react-redux';
import { setUserLogout } from './core-module/redux/Auth/actions';
import { checkForNewVersion } from './helpers/VersionHelper';

interface Props {
  auth: DefaultAuthState;
  dispatch: Dispatch;
}

class App extends React.Component<Props> {
  componentWillMount() {
    if (this.makeLogoutAfterExpiredToken()) {
      this.doLogoutAfterExpiredToken();
    }
  }

  componentDidMount() {
    window.setInterval(() => {
      checkForNewVersion();
    }, 30000);
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any) {
    if (this.makeLogoutAfterExpiredToken()) {
      this.doLogoutAfterExpiredToken();
    }
  }

  makeLogoutAfterExpiredToken() {
    const { auth } = this.props;

    return auth.isLoggedIn && !isTokenValid(auth.user.created, auth.user.ttl);
  }

  doLogoutAfterExpiredToken() {
    this.props.dispatch(setUserLogout());
  }

  render = () => (
    <LocaleProvider locale={nl_NL}>
      <Router>
        <AppRouter />
      </Router>
    </LocaleProvider>
  );
}

const mapStateToProps = (state) => ({
  app: state.app,
  auth: state.auth
});

export default connect(mapStateToProps)(errorBoundry(App));
